import React from 'react';
import { Can } from '../Can';
import {
    Alert,
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCancel,
    faExclamationCircle,
    faPaperPlane,
} from '@fortawesome/free-solid-svg-icons';
import { util } from '../Util';
import { ApiRoutes } from '../ApiRoutes';
import { toasty } from '../common/forms/FormElements';

export default class EmployeeInviteButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            saving: false,
        };
    }

    toggleModal = () => {
        const { showModal, saving } = this.state;

        if (saving) {
            return;
        }

        this.setState({ showModal: !showModal });
    };

    onInviteClick = async () => {
        const { saving } = this.state;

        if (saving) {
            return;
        }

        this.setState({ saving: true });

        const { employee } = this.props;

        try {
            const inviteResponse = await util.fetch.andGetResponse(
                util.fetch.types.post,
                ApiRoutes.employeeAdmin.invite(employee.id),
                null,
                'Error Sending Invitation'
            );

            if (inviteResponse) {
                toasty.success(
                    'Invitation(s) Sent',
                    `Invitation(s) have been sent to ${employee.lastName}, ${employee.firstName}`
                );

                this.setState({ showModal: false });
            }
        } catch (e) {
            console.error(e);
        } finally {
            this.setState({ saving: false });
        }
    };

    render() {
        const { employee } = this.props;

        const { showModal, saving } = this.state;

        if (!employee || !employee.id) {
            return null;
        }

        const { smsNotify, emailNotify } = employee;

        const noNotificationsSet = !smsNotify && !emailNotify;

        return (
            <Can I="edit" a="employee">
                <Button
                    type="button"
                    onClick={this.toggleModal}
                    color="info"
                    outline
                    className="w-100"
                >
                    <FontAwesomeIcon icon={faPaperPlane} className="mr-1" />
                    Invite to FAQTS
                </Button>

                <Modal
                    isOpen={showModal}
                    toggle={this.toggleModal}
                    fade={false}
                    size="xl"
                >
                    <ModalHeader toggle={this.toggleModal}>
                        Inviting {employee.lastName}, {employee.firstName}
                    </ModalHeader>
                    <ModalBody>
                        {noNotificationsSet && (
                            <div>
                                The invite process cannot proceed unless either
                                (or both) email or SMS notifications are enabled
                                for this employee.
                            </div>
                        )}

                        {!noNotificationsSet && (
                            <div>
                                <div>
                                    Clicking invite will...
                                    <ul>
                                        {emailNotify && (
                                            <li>
                                                Send an invitation via email
                                            </li>
                                        )}
                                        {smsNotify && (
                                            <li>
                                                Send an invitation via text
                                                message
                                            </li>
                                        )}
                                    </ul>
                                </div>

                                <Alert color="info" fade={false}>
                                    <div className="d-flex">
                                        <div className="mr-2">
                                            <FontAwesomeIcon
                                                icon={faExclamationCircle}
                                            />
                                        </div>
                                        <div>
                                            <div>
                                                The employee's password will be
                                                reset to a randomly-generated
                                                value. They will be unable to
                                                interact with FAQTS until they
                                                have reset their password.
                                            </div>

                                            <div>
                                                The employee will need to know
                                                the email address associated
                                                with their FAQTS user account to
                                                reset their password.
                                            </div>
                                        </div>
                                    </div>
                                </Alert>
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <div className="d-flex w-100">
                            <div className="mr-auto">
                                <Button
                                    type="button"
                                    color="warning"
                                    outline
                                    onClick={this.toggleModal}
                                    disabled={saving}
                                >
                                    <FontAwesomeIcon
                                        icon={faCancel}
                                        className="mr-1"
                                    />
                                    Cancel
                                </Button>
                            </div>
                            <div className="ml-auto">
                                <Button
                                    type="button"
                                    color="success"
                                    disabled={noNotificationsSet || saving}
                                    onClick={this.onInviteClick}
                                >
                                    <FontAwesomeIcon
                                        icon={faPaperPlane}
                                        className="mr-1"
                                        pulse={saving}
                                    />
                                    Send Invitation
                                </Button>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>
            </Can>
        );
    }
}
